import React, { useCallback, useContext, useRef } from 'react';
import classnames from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import LazyContext from '@wix/da-react-context/pkg/LazyImageContext';
import { useSliderOverflow } from './hooks/useSliderOverflow';
import { useSliderScrollToIndex } from './hooks/useSliderScrollToIndex';
import { useSliderScrollHandler } from './hooks/useSliderScrollHandler';
import DefaultPreviousButton from './lego/DefaultPreviousButton';
import DefaultNextButton from './lego/DefaultNextButton';
import s from './Slider.scss';
const Slider = ({ smoothInitialScroll = true, scrollBy = 0.5, scrollSnap, className, height, children, disableScroll, slimSpacing, wideSpacing, noSpacing, permArrows, arrowSize, dataHook, contentClassName, disableArrows, renderNextButton, renderPrevButton, scrollToIndex, onScrollBiData, enableMobileSwipeLogging, stableWidthButtons, forceMobileArrows })=>{
    const rootRef = useRef(null);
    const contentRef = useRef(null);
    const isMobile = useContext(MobileContext);
    const itemCount = React.Children.count(children);
    const overflow = useSliderOverflow(contentRef, itemCount);
    const handleScrollBtnClick = useSliderScrollHandler(contentRef, scrollBy, onScrollBiData, enableMobileSwipeLogging);
    useSliderScrollToIndex(contentRef, rootRef, scrollToIndex, smoothInitialScroll);
    const withControls = !isMobile && !disableArrows || forceMobileArrows;
    const handlePrevClick = useCallback((e)=>handleScrollBtnClick(e, 'previous'), [
        handleScrollBtnClick
    ]);
    const handleNextClick = useCallback((e)=>handleScrollBtnClick(e, 'next'), [
        handleScrollBtnClick
    ]);
    return /*#__PURE__*/ React.createElement(LazyContext.Provider, {
        value: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], overflow && s[`overflow-${overflow}`], slimSpacing && s['slim-spacing'], wideSpacing && s['wide-spacing'], noSpacing && s['no-spacing'], permArrows && s['perm-arrows'], stableWidthButtons && s['stable-width-buttons'], className),
        style: {
            height
        },
        ref: rootRef,
        "data-hook": dataHook
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Slider"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content'], disableScroll && s['no-scroll'], scrollSnap && s['scroll-snap'], contentClassName),
        ref: contentRef,
        draggable: "false"
    }, children), withControls && /*#__PURE__*/ React.createElement(React.Fragment, null, renderPrevButton ? renderPrevButton({
        onClick: handlePrevClick,
        className: s['custom-prev-btn']
    }) : /*#__PURE__*/ React.createElement(DefaultPreviousButton, {
        arrowSize: arrowSize,
        onClick: handlePrevClick
    }), renderNextButton ? renderNextButton({
        onClick: handleNextClick,
        className: s['custom-next-btn']
    }) : /*#__PURE__*/ React.createElement(DefaultNextButton, {
        arrowSize: arrowSize,
        onClick: handleNextClick
    })))));
};
Slider.displayName = 'Slider';
export default Slider;

//# sourceMappingURL=Slider.js.map